<template>
  <div class="course-history">
    <table>
      <thead>
        <tr>
          <th>No.</th>
          <th>Course</th>
          <th>Special<br />consideration</th>
          <th>before<br />wetec</th>
          <th>after<br />wetec</th>
          <th>Lesson</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="history of histories" :key="history.no">
          <td>{{ history.no }}</td>
          <td>{{ history.courseName }}</td>
          <td>
            <p v-for="specialConsideration, idx of history.specialConsiderations" :key="idx">
              {{ specialConsideration.specialConsideration.name }}
            </p>
            <b-button
              v-if="hasAuth(['admin'])"
              pill variant="secondary"
              size="sm"
              class="add-button"
              @click="showModal(history)"
            >
              Add
              <font-awesome-icon class="plus" icon="plus"/>
            </b-button>
          </td>
          <td>{{ history.wetecBefore | formatdec }}</td>
          <td>{{ history.wetecAfter | formatdec  }}</td>
          <td>
            <b-button
              pill
              variant="secondary"
              :to="{
                name: 'StudentCourseGrades',
                params: {
                  studentId,
                  courseHistoryId: history.courseHistoryId
                }
              }"
            >
              Detail
            </b-button>
          </td>
        </tr>
      </tbody>
    </table>
    <SpecialConsiderationModal ref="specialConsiderationModal" />
  </div>
</template>

<script lang='ts'>
import _ from 'lodash'
import { Vue, Prop, Component } from 'vue-property-decorator'
import { CourseHistory } from '@/store/students/types'
import SpecialConsiderationModal from '@/components/parts/students/SpecialConsiderationModal.vue'
import { RootState } from '@/store/types'

@Component({
  components: {
    SpecialConsiderationModal,
  },
  filters: {
    formatdec(v: string|null): string {
      if (!v) return ''
      return parseFloat(v).toFixed(2)
    },
  },
})
export default class StudentCourseHistory extends Vue {
  @Prop() histories!: CourseHistory[]

  private get studentId(): string {
    return this.$route.params.id
  }

  private showModal(selectedHistory: CourseHistory) {
    (this.$refs.specialConsiderationModal as SpecialConsiderationModal).open(selectedHistory);
  }

  hasAuth(acceptRoles: string[]): boolean {
    const auth = (this.$store.state as RootState).auth.profile?.authority
    return _.indexOf(acceptRoles, auth) !== -1
  }
}
</script>

<style scoped>
.course-history {
  height: 420px;
  overflow-y: scroll;
}
table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  margin-bottom: 10px;
}

table thead th, table thead td {
  padding: 20px;
  text-align: center;
}

table tbody tr:nth-child(odd) {
  background: #d8d8d8;
}
table th {
  background-color: #fff;
  position: sticky;
  top: 0;
  border-top:#fff;
}
th:before{
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  border-top: 2px solid #DBDBDB;
  border-bottom: 2px solid #DBDBDB;
}
th:first-child:before {
  border-left: 2px solid #DBDBDB;
}
th:last-child:before {
  border-right: 2px solid #DBDBDB;
}
table td {
  height: 50px;
  padding: 10px 20px;
  text-align: center;
}

.add-button {
  min-width: 50%;
  font-size: 0.6rem;
  line-height: 1;
}

</style>
